module.exports = __webpack_public_path__ + "static/media/Portrait-10041.f3e20a9f.jpg";